export default "__VITE_ASSET__4kdETiJ5__"